import React, { Suspense, useEffect, useState } from "react";
import { request } from "../map/mapData";
import "./../../styles/map.css";
import { useInView } from "react-intersection-observer";

const MapY = React.lazy(() => import("../map/map"));

const SectionInfrostrukture = ({ data, hcDesc, estate, mapData }: any) => {
  let [ref, inView] = useInView({
    triggerOnce: true, // Компонент загружается только один раз
    threshold: 0.9, // Загрузка начинается, когда 10% компонента видны
    // skip: skipStatus ? true : false, // меняем на true при клике на иконку поделиться. Observer прекратит работу. (сейчас возможно уже не нужно)
  });

  return (
    <div>
      {/*{*/}
      {/*    // skipStatus &&*/}
      {/*    !inView ?*/}
      {/*        <Suspense fallback={<div>Loading...</div>}>*/}
      {/*            <MapY coordinates={{*/}
      {/*                latitude: data.latitude,*/}
      {/*                longitude: data.longitude,*/}
      {/*            }} request={request} hcDesc={hcDesc} fromPDF={false}/>*/}
      {/*        </Suspense>*/}
      {/*        :*/}
      {/*        <div ref={ref}>*/}
      {/*            {inView ? (*/}
      {/*                <Suspense fallback={<div>Loading...</div>}>*/}
      {/*                    <MapY coordinates={{*/}
      {/*                        latitude: data.latitude,*/}
      {/*                        longitude: data.longitude,*/}
      {/*                    }} request={request} hcDesc={hcDesc} fromPDF={false}/>*/}
      {/*                </Suspense>*/}
      {/*            ) : (*/}
      {/*                <div>Компонент загрузится, когда попадет в видимую область экрана.</div>*/}
      {/*            )}*/}
      {/*        </div>*/}
      {/*}*/}
      <div ref={ref}>
        {inView ? (
          <Suspense
            fallback={
              <div className="flex items-center justify-center h-full">
                загружаем карту...
              </div>
            }
          >
            <MapY
              coordinates={{
                latitude: data.latitude,
                longitude: data.longitude,
              }}
              mapObjects={mapData}
              request={request}
              hcDesc={hcDesc}
              fromPDF={false}
            />
          </Suspense>
        ) : (
          <div>
            Компонент загрузится, когда попадет в видимую область экрана.
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionInfrostrukture;
